module.exports = __webpack_public_path__ + "static/media/loginLogo.50f60ca7.png";